import barba from "@barba/core";
import { delay, paginationControls } from "../components/utils";
import { cluesInit } from "../components/clue";
import { initNarrative } from "../components/narrative";
import { setStoreQuestionValue, getStoreQuestionValue } from "../components/stores";
import { wysiwyg } from "../components/wysiwyg";
import { workbook } from "../components/workbook";
import { audio } from "../components/audio";
import { sFX } from "../components/sfx";

const escape_q13 = () => {
    delay(500).then(() => {

    // --------------------------------------------------
    // question
    // --------------------------------------------------
    let questionIndex = 13;
    let questionPart = 0;
    let questionPart2 = 1;
    let digits = { value1: "00", value2: "00" };
    const number1 = document.querySelector(".number-1");
    const number2 = document.querySelector(".number-2");

    // --------------------------------------------------
    // methods
    // --------------------------------------------------
    paginationControls(questionIndex);
    cluesInit();
    initNarrative();
    wysiwyg();
    workbook();
    audio();
  
    // --------------------------------------------------
    // modify storage
    // --------------------------------------------------

    // elems
    let textarea = document.querySelector('#working');

    // get localStorage
    let storedValue = getStoreQuestionValue("assessment", "questions", questionIndex, questionPart);
    let storedValue2 = getStoreQuestionValue("assessment", "questions", questionIndex, questionPart2);
   
    if(storedValue) {
        textarea.value = storedValue;
    }

    if (storedValue2 !== "") {
        if (typeof storedValue2 === "object" && storedValue2 !== null) {
          number1.value = storedValue2.value1;
          number2.value = storedValue2.value2;
        }
      }

    // set localStorage
    const setLocalStorage = (link) => {
        digits.value1 =  number1.value;
        digits.value2 =  number2.value;
        setStoreQuestionValue("assessment", "questions", questionIndex, questionPart, textarea.value);
        setStoreQuestionValue("assessment", "questions", questionIndex, questionPart2, digits);
        barba.go(link);
    }

    // --------------------------------------------------
    // slide navigation
    // --------------------------------------------------
    const next = document.querySelector(".js-next");
    const prev = document.querySelector(".js-prev");
    if(prev){
        prev.addEventListener("click", (e) => {
            e.preventDefault();
            setLocalStorage(e.target.href);
        });
    }
    if(next){
        next.addEventListener("click", (e) => {
            e.preventDefault();
            setLocalStorage(e.target.href);
        });
    }
    
});
};

export { escape_q13 };
